import { Link } from 'react-router-dom';

const stats = [
  { value: '5000+', label: '收录影视', icon: 'ri-film-line' },
  { value: '每日', label: '持续更新', icon: 'ri-refresh-line' },
  { value: '中文字幕', label: '同步播放', icon: 'ri-translate-2' },
  { value: '全端', label: '手机可看', icon: 'ri-smartphone-line' },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-primary-50">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-medium mb-4">
            <i className="ri-shield-star-line"></i>
            免费观看 · 中文字幕
          </span>
          <h1 className="font-heading font-black text-2xl md:text-4xl text-primary-900 leading-tight mb-4">
            亚洲中文字幕在线观看
          </h1>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            本站是一个专注亚洲影视的内容站点，汇集来自中国大陆、中国香港、中国台湾、日本、韩国、泰国等地区的
            <strong className="text-primary-800">电影、电视剧与综艺节目</strong>，全站资源支持中文字幕，为影迷提供清晰分类与便捷浏览体验。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
            你可以通过分类筛选、地区与年份条件快速找到想看的作品，也可以在详情页了解剧情简介与演职人员。所有播放入口均为展示用途，代表内容将持续扩展。
          </p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-700 hover:bg-primary-800 text-white text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-compass-3-line text-lg"></i>
              开始探索
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50 border border-primary-200 text-primary-700 hover:bg-primary-100 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-information-line text-lg"></i>
              了解本站
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-5">
          {stats.map((s) => (
            <div key={s.label} className="p-4 md:p-5 rounded-lg bg-background-50 border border-primary-100">
              <span className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${s.icon} text-xl md:text-2xl`}></i>
              </span>
              <p className="font-heading font-black text-xl md:text-2xl text-primary-900 mt-3">{s.value}</p>
              <p className="text-xs md:text-sm text-foreground-600 mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}